import {GLOBALFILTER_DATA_FAILURE, GLOBALFILTER_DATA_REQUEST, GLOBALFILTER_DATA_SUCCESS} from "../actionTypes";

export const getGlobalFilterDataRequest = (payload: any) => ({
    type: GLOBALFILTER_DATA_REQUEST,
    payload
});

export const getGlobalFilterDataSuccess = (payload: any) => ({
    type: GLOBALFILTER_DATA_SUCCESS,
    payload
});
export const getGlobalFilterDataError= (payload: any) => ({
    type: GLOBALFILTER_DATA_FAILURE,
    payload
});
